module.exports = __webpack_public_path__ + "img/11.211ff2a7.png";